import { useParams } from 'react-router-dom'

import { useRequest } from 'common/hooks/useRequest'
import { TriggerEndpointKeys, TriggerService } from 'common/services/trigger'

export const useTriggerRequest = () => {
  const { hash: transmissionCode } = useParams<{ hash: string }>()

  const request = useRequest([TriggerEndpointKeys.getAllTriggers, transmissionCode], () =>
    TriggerService.getAllTriggers(transmissionCode)
  )

  return request
}
